import * as React from 'react';
import { theme } from '../../../theme';

interface Props {
  color?: string;
}

export const DownloadIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 13.334H12"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 10.666V2.66602"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6654 8C10.6654 8 8.70136 10.6667 7.9987 10.6667C7.29596 10.6667 5.33203 8 5.33203 8"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
